import { Form } from 'formik';
import { FormInputWithLabel } from '../../../_core/form/input/form-labelled-input.component';
import { PropsWithChildren } from 'react';
import { ISendCustomRequestMessageParams } from '../../request/request.types';
import { IMultiSelectOption } from '../../../_core/input/multiselect-input.component';

export interface ISendCustomRequestGroupMessageFormParams
  extends Omit<ISendCustomRequestMessageParams, '_id' | 'notify' | 'to' | 'replyTo'> {
  assignSelf: boolean;
  replyTo: IMultiSelectOption[];
}

export const SendRequestGroupMessageFormFields = ({
  children,
  forceSendAll,
  replyToOptions
}: PropsWithChildren & { forceSendAll?: boolean; replyToOptions: IMultiSelectOption[] }) => {
  return (
    <Form action="#" method="POST" className="sm:max-w-xl mx-auto space-y-4 mt-10">
      {!!forceSendAll && <FormInputWithLabel name="assignSelf" label="Assign me to all new requests" type="checkbox" />}
      <FormInputWithLabel
        name="replyTo"
        label="Reply To:"
        type="multiselect"
        placeholder="Select email"
        multiSelectProps={{ singleSelect: true, options: replyToOptions, nullable: true }}
      />
      <FormInputWithLabel
        name="subject"
        label="Subject:"
        type="text"
        placeholder="You have received a new message on one of your Request's"
      />
      <FormInputWithLabel name="message" label="Message:" placeholder="Enter your message here..." type="textarea" />
      {children}
    </Form>
  );
};
